import React, { useEffect, useState } from "react";
import "../pages/styles/changelog.css";
import "../pages/styles/home.css";
import "./styles/mediaqueries.css";
import logo from "../Assets/images/Logo_Square_mini.png";
import bgFrame from "../Assets/images/changelog-frame.png";
import Footer from "../components/Footer";
import axios from "axios";
import moment from "moment/moment";
import parse from "html-react-parser";
import Dompurify from "dompurify";

const Changelog = () => {
  const [changelogData, setChangelogData] = useState(null);

  function formatDescription(description) {
    if (description) {
      let formattedDescription = description?.replace(
        /<#([a-fA-F0-9]{6})>/g,
        '<span style="color: #$1;">'
      );
      formattedDescription = formattedDescription.replace(
        /<\/color>/g,
        "</span>"
      );

      formattedDescription = formattedDescription.replace(/<u>/g, "<u>");
      formattedDescription = formattedDescription.replace(/<\/u>/g, "</u>");
      formattedDescription = formattedDescription.replace(/\[b]/g, "<b>");
      formattedDescription = formattedDescription.replace(/\[\/b]/g, "</b>");

      formattedDescription = formattedDescription.replace(
        /<link=\"{{[^}]*}}\">/g,
        ""
      );
      formattedDescription = formattedDescription.replace(/<\/link>/g, "");
      let sanitizedHtml = Dompurify.sanitize(formattedDescription);
      return parse(sanitizedHtml);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Roshpit Champions II | Changelog";
    try {
      axios
        .get(`https://cotp-game.azurewebsites.net/api/SiteGoogleSheet`)
        .then((res) => {
          res.data.forEach((item) => {
            item.changes = formatDescription(item.changes);
          });

          setChangelogData(res.data);
        });
    } catch (e) {
      console.log("error", e);
    }
  }, []);
  return (
    <>
      <div className="changelog_container">
        <p className="changelog_container_heading">
          Changelogs
          <span>
            Change Log for Game, Patch Notes, Major Changes, and Other Updates
            will be posted here.
          </span>
        </p>
        {changelogData === null ? (
          <div className="video_overlay1">
            <div className="lds-ripple">
              <div></div>
              <div></div>
            </div>
            <p>Loading Changelogs...</p>
          </div>
        ) : (
          <div className="changelogs container">
            {changelogData?.length === 0 ? (
              <p>No Data Found</p>
            ) : (
              changelogData?.map((item, index) => {
                return (
                  <div className="changelog" key={index}>
                    {/* <img src={bgFrame} alt="" className="changelog-frame" /> */}
                    <div className="changelog_title">
                      <p>{item.tittle}</p>
                      <span>
                        {moment(item.dateTimeUtc).format("MM-DD-YYYY")}
                      </span>
                    </div>
                    {/* <div
                      className="changelog_desc"
                      dangerouslySetInnerHTML={{
                        __html: item?.changes,
                      }}
                    ></div> */}
                    <div className="changelog_desc"> {item?.changes}</div>
                  </div>
                );
              })
            )}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Changelog;
